import {Box, Tooltip, Typography} from "@mui/material";
import moment from "moment-timezone";
import {COMPACT_TIME_FORMAT} from "../../config/DateTimeConstants";

export default function ShiftLabel({event}) {
    const startDate = moment(event.start).format(COMPACT_TIME_FORMAT);
    const endDate = moment(event.end).format(COMPACT_TIME_FORMAT);
    const labelStyle = {textOverflow: 'ellipsis', overflow: 'hidden', variant: 'body2'};

    return <Box className="text-ellipsis">
            <Tooltip title={`${startDate} - ${endDate}`}>
                <Typography sx={labelStyle}>{`${startDate} - ${endDate}`}</Typography>
            </Tooltip>
        </Box>;
}
